module.exports = __webpack_public_path__ + "static/img/076.87cca24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/076.png
// module id = cMmv
// module chunks = 0